import ButtonLink from 'components/ExternalLink/ExternalLink';
import './ModalTitleWithButton.scss';

type ModalTitleWithButtonProps = {
  title: string;
  url: string;
  urlLabel?: string;
};

export const ModalTitleWithButton = ({ title, url, urlLabel }: ModalTitleWithButtonProps) => {
  return (
    <div className="modal-title-with-button-container">
      {title}
      <ButtonLink label={urlLabel} url={url} className="modal-title-with-button" />
    </div>
  );
};
